module.exports = __webpack_public_path__ + "img/sales_by_location.33d1c10e.svg";